<template>
    <div class="flex rounded-xl bg-grind p-8 text-white">
        <ClientOnly>
            <NewsletterSignup
                :heading="heading"
                :submit-button-label="submitLabel"
                :submit-button-on-bottom="true"
                tag="footer"
            >
                <WysiwygContent :content="text" />
            </NewsletterSignup>
        </ClientOnly>
    </div>
</template>

<script setup lang="ts">
import NewsletterSignup from '~/components/social/NewsletterSignup.vue';

withDefaults(
    defineProps<{
        heading?: string;
        text?: string | null;
        submitLabel?: string;
    }>(),
    {
        heading: 'NEWSLETTER SIGN UP',
        text: null,
        submitLabel: 'Sign up',
    },
);
</script>
